import { apiClient } from '@/api/client';

/**
 * Sector/Subsector taxonomy API surface (MYN-46). Small, near-static dataset
 * (~18 sectors / ~90 subsectors) - fetched once and prefetched/cached rather
 * than hardcoded, so a client-requested taxonomy change is a seed update on
 * the Backend, not a Frontend deploy.
 */
export interface Subsector {
  id: number;
  name: string;
}

export interface Sector {
  id: number;
  name: string;
  subsectors: Subsector[];
}

export async function fetchSectors(): Promise<Sector[]> {
  const { data } = await apiClient.get<Sector[]>('/taxonomy/sectors');
  return data;
}
